import axiosNewApi from "../config/axiosNewApi";

export const machineGroups = async () => {
  try {
    const { data, status } = await axiosNewApi.get(`mobile/my-machines/groups`, {
      withCredentials: true,
    });

    if (status === 200) {
      return data;
    } else {
      throw new Error("not found");
    }
  } catch (error) {
    throw error;
  }
};

export const machineInGroups = async (id) => {
  try {
    const { data, status } = await axiosNewApi.get(`mobile/my-machines/groups/${id}`, {
      withCredentials: true,
    });

    if (status === 200) {
      return data;
    } else {
      throw new Error("not found");
    }
  } catch (error) {
    throw error;
  }
};

export const fetchFiltersForMachine = async (id) => {
  try {
    const { data, status } = await axiosNewApi.get(
      `mobile/my-machines/filters/${id}`,
      {
        withCredentials: true,
      }
    );

    if (status === 200) {
      return data;
    } else {
      throw new Error("not found");
    }
  } catch (error) {
    throw error;
  }
};
